<template>
  <div class="steps-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles.scss";

.steps-header {
  text-align: center;
  padding: 30px 0px 30px;
  @include mq-up(md) {
    padding: 40px 20px 60px;
  }
  :deep(.heading) {
    color: $primary;
    font-weight: bold;
    font-size: 20px;
    @include mq-up(md) {
      font-size: 32px;
      line-height: 48px;
    }
  }
}
</style>
